import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import './FAQ.css';

const FAQ = () => {
  const [faqItems, setFaqItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [title, setTitle] = useState('Frequently Asked Questions');
  const [subtitle, setSubtitle] = useState('Get answers to common questions');

  useEffect(() => {
    fetchFAQ();
  }, []);

  const fetchFAQ = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        setFaqItems(response.data.data.faq || []);

        const sections = response.data.data.sections || [];
        const faqSection = sections.find(s => s.section_key === 'faq');

        if (faqSection && faqSection.content) {
          const titleContent = faqSection.content.find(c => c.content_key === 'faq_title');
          const subtitleContent = faqSection.content.find(c => c.content_key === 'faq_subtitle');

          if (titleContent) setTitle(titleContent.content_value);
          if (subtitleContent) setSubtitle(subtitleContent.content_value);
        }
      }
    } catch (error) {
      console.error('Failed to fetch FAQ:', error);
    }
  };

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="faq-container">
          {faqItems.map((item, index) => (
            <div key={item.id} className="faq-item">
              <button
                className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                {item.question}
                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${activeIndex === index ? 'show' : ''}`}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
